import React  from "react";
import UseForm from "components/companies/UseForm";
import { useConfiguration } from "./context";

export default function New(){
  const { configuration, isLoading } = useConfiguration();
  return (<UseForm configuration={configuration} isLoading={isLoading} type={"ies_board"}/>);
}
